import React, { useContext } from 'react';
import { Row, Col } from 'antd';

import ThemeContext from '../../../context/theme';

interface Porps {
  items: string[]
  height: number
  select: number
  onChange: Function
}

const ONE_DIVISION = 24;

const BottomNav = (props: Porps) => {
  const theme = useContext(ThemeContext);

  const defaultColumnStyle: React.CSSProperties = {
    backgroundColor: theme.background.bottomNav,
    textAlign: "center",
    padding: 10,
    color: "#eee"
  }

  const span = ONE_DIVISION / props.items.length

  return (
    <Row
      style={{
        position: 'fixed',
        bottom: 0,
        width: "100%",
        height: props.height,
      }}
    >
      {props.items.map((item: string, idx: number) => (
        <Col
          span={span}
          style={{
            ...defaultColumnStyle,
            color: props.select === idx ? theme.color.bottomNavSelect : theme.color.bottomNavUnSelect,
            fontWeight: props.select === idx ? 600 : 400,
            opacity: props.select === idx ? 1 : .7
          }}
          onClick={() => props.onChange(idx)}
        >{item}</Col>
      ))}
    </Row>
  );
};

export default BottomNav;
